<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 6 10"
    fill="none"
    style="enable-background:new 0 0 6 10;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <path
      id="icon_arrow_left"
      d="M0.484375 4.53125C0.347656 4.66797 0.347656 4.85938 0.484375 4.99609L4.50391 9.04297C4.61328 9.17969 4.83203 9.17969 4.96875 9.04297L5.48828 8.49609C5.625 8.35938 5.625 8.16797 5.48828 8.03125L2.26172 4.75L5.48828 1.49609C5.625 1.35938 5.625 1.14062 5.48828 1.03125L4.96875 0.484375C4.83203 0.347656 4.61328 0.347656 4.50391 0.484375L0.484375 4.53125Z"
      fill="#9AABB8"
    />
  </svg>
</template>
<style scoped>
.icon-ball {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-arrow-left"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>